import React from 'react';

import { SOLUTION_SUB_ROUTES, QUIZ_SUB_ROUTES } from '../../../constant';

import SolutionListView from './SolutionList.view';

const SolutionList = ({ match, history, solutionData, variant }) => {
  const { round, score, fullScore, results, isShowScore } = solutionData;
  const { examId, examSessionId } = match.params;

  return (
    <SolutionListView
      variant={variant}
      onBack={() => history.push(QUIZ_SUB_ROUTES.LANDING.getPath(examId))}
      round={round}
      score={score}
      fullScore={fullScore}
      results={results}
      isShowScore={isShowScore}
      onSeeDetailSolution={(examPaperItemId) =>
        history.push(
          SOLUTION_SUB_ROUTES.SOLUTION_DETAIL.getPath(examId, examSessionId, examPaperItemId)
        )
      }
    />
  );
};

export default SolutionList;
